module.exports = __webpack_public_path__ + "static/img/demo2.1784115679763.png";